import { render, staticRenderFns } from "./message.vue?vue&type=template&id=34836617&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=34836617&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34836617",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34836617')) {
      api.createRecord('34836617', component.options)
    } else {
      api.reload('34836617', component.options)
    }
    module.hot.accept("./message.vue?vue&type=template&id=34836617&scoped=true", function () {
      api.rerender('34836617', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/agent-messages/message.vue"
export default component.exports